import { Stack, StackProps } from '@mui/material'
import { styled } from 'styles/styled'

export const LocationTabContainer = styled((props: StackProps) => (
  <Stack width="100%" height="100%" {...props} gap={{ md: 2 }} />
))`
  position: relative;
  justify-content: space-between;
  padding: 8px 8px 16px;
`
